/**
 * できなかった reasons for 行動記録 — one list for the chat record (AiRecord / AiHome), the
 * 目標 past-days sheet (CheckinSheet) and the home popup (CheckinPopup). The label is what gets
 * saved as the reason text. The 5 labels are UI 案 B (owner 2026-10-26); records saved before
 * keep their old labels (the reason is stored as text, nothing is rewritten).
 */
export const CHECKIN_REASONS = [
  { label: '対象のお客様がいなかった', tip: '対象のお客様が来た日に、忘れずに試せるよう準備しておきましょう。' },
  { label: '時間が足りなかった', tip: '忙しい日ほど、会計前の30秒だけと決めておくと続けやすいです。' },
  { label: 'うっかり忘れた', tip: 'カルテに「次回提案」と1行メモしておくと、忘れにくくなります。' },
  { label: 'タイミングが合わなかった', tip: '仕上げ後・鏡の前が、いちばん自然に切り出せるタイミングです。' },
  { label: 'その他', tip: '「ひと言」に理由を残すと、AIの振り返りに生かされます。' },
];

/** ひと言（任意）max length — same as the server (action_checkins_service.MEMO_MAX_LEN). */
export const CHECKIN_MEMO_MAX = 100;

/** Days shown in the 目標 strip (at-a-glance). */
export const CHECKIN_STRIP_DAYS = 7;
/** How far back a stylist may record, today included — 1 month (server enforces the same: goals.py). */
export const CHECKIN_BACKFILL_DAYS = 31;
